import { classNames } from "../../helpers/classNames";

/**
 * Loading placeholders (docs/design/HANDOFF.md, "Loading"): shapes in the
 * same layout as the real content, pulsing. Compose them per screen.
 *
 *   line   a text line (h-4, full width)
 *   block  a card or image area (h-14, rounded)
 *   pill   a chip or button (h-10, round)
 *   cover  a book cover (portrait)
 */
const SHAPES = {
  line: "h-4 w-full rounded",
  block: "h-14 w-full rounded-2xl",
  pill: "h-10 w-24 rounded-full",
  cover: "aspect-[3/4] w-20 rounded-lg",
};

const Skeleton = ({ shape = "line", className, ...rest }) => (
  <div
    aria-hidden="true"
    className={classNames("animate-pulse bg-md-pink-light-1", SHAPES[shape] || SHAPES.line, className)}
    {...rest}
  />
);

/** Wraps a set of skeletons so screen readers hear one "Loading" status. */
export const SkeletonGroup = ({ label = "Loading", className, children }) => (
  <div role="status" aria-label={label} className={className}>
    {children}
  </div>
);

export default Skeleton;
